module.exports = __webpack_public_path__ + "img/发光2.c25f0321.png";